import { TransferInterface } from 'types/PaymentsInterface'
import AxiosInstance from './apiAdapter'

export const addCard = (card: {
  cardHolderName: string
  pan: string
  expiryDate: string
  cvv: string
}) =>
  AxiosInstance.post(`/cards`, card)


export const getBanks = () =>
  AxiosInstance.get(`/payments/banks`)

export const getBankAccountInfo = (accountNumber: string, bankCode: string) =>
  AxiosInstance.get(`payments/name-enquiry?accountNumber=${accountNumber}&bankCode=${bankCode}`)

// AxiosInstance.get(`/fxRates/findApprovedFxRateByStatus?baseCurrency=USD&exchangeCurrency=GBP`)

export const getActiveFxRate = (baseCurrency: string, exchangeCurrency: string) =>
  AxiosInstance.get(`/fx-rates/active-fx-rate?baseCurrency=${baseCurrency}&exchangeCurrency=${exchangeCurrency}`)


export const getFxRatesHistory = (baseCurrency: string, exchangeCurrency: string, startDate: string, endDate: string) =>
  AxiosInstance.get(`/fx-rates/history?baseCurrency=${baseCurrency}&exchangeCurrency=${exchangeCurrency}&startDate=${startDate}&endDate=${endDate}`)


export const transfer = (data: TransferInterface) =>
  AxiosInstance.post(`/payments/transfer`, data)

export const process3DSDD = (href: string, data: { collectionReference: string }) =>
  AxiosInstance.post(`/payments/process3DSDD?href=${href}`, data)

